<template>
    <div>
        <navigation></navigation>
        <div class="main-wrapper">
            <div class="row">
                <div class="phone-wrapper col-lg-4 col-sm-6 col-xs-12" v-for="(brand,i) in brands">
                    <router-link :to="{name: 'models', query: {brandName: brand}}">
                        <div class="phone">
                            <div class="block-img-wrapper">
                                <img :src="$root.$data.phonesObject[brand].img" alt="">
                            </div>
                            <div class="phone-name">
                                <p>{{brand}}</p>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Navigation from './Navigation'

export default {
  components: {Navigation},
  name: 'phone-brands',
  data () {
    return {
      brands: []
    }
  },
  methods: {

  },

  created () {
    this.brands = Object.keys(this.$root.$data.phonesObject)
  }

}
</script>

<style scoped>

</style>
